import { render, staticRenderFns } from "./businessProduct.vue?vue&type=template&id=722a9d3b&scoped=true&"
import script from "./businessProduct.vue?vue&type=script&lang=js&"
export * from "./businessProduct.vue?vue&type=script&lang=js&"
import style0 from "./businessProduct.vue?vue&type=style&index=0&id=722a9d3b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a9d3b",
  null
  
)

export default component.exports